export default "__VITE_ASSET__DyhpN5Qj__"